export enum MarketingPreference
{
    DisallowAll          = 0,
    AllowMarketing       = 1 << 0,  // 00000001
    AllowUpdates         = 1 << 1,  // 00000010
}